import React, { Component } from 'react';
import { Line, Bar, Radar } from 'react-chartjs-2';
import { Grid, Header, Icon, Segment, Table, Checkbox, Dropdown, Container, Radio, Button } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import TypeList from '../filter2.json';
import { connect } from 'react-redux';
import Page from '../../components/Page';
import { withTranslation } from 'react-i18next';
import 'moment/locale/tr';
import MockAgents from './mock.json';
import { it } from 'date-fns/locale';
import agent from './agent';

const ChartWrap = (props) => (
	<Grid.Column width={props.width}>
		<Header as="h4" attached="top" style={{ display: 'flex' }}>
			<Icon name={props.icon || 'chart bar'} />
			<Header.Content>{props.title}</Header.Content>
			{props.content}
		</Header>
		<Segment attached>{props.children}</Segment>
	</Grid.Column>
);

const barOptions = {
	scales: {
		xAxes: [{ stacked: false }],
		yAxes: [{ stacked: false, ticks: { min: 0 } }],
	},
	tooltips: {
		mode: 'index',
		intersect: false,
		filter: (a) => a.yLabel,
	},
	hover: {
		mode: 'nearest',
		intersect: true,
	},
	legend: {
		display: true,
		labels: { fill: false },
	},
};
const barOptionsStack = {
	scales: {
		xAxes: [{ stacked: true }],
		yAxes: [{ stacked: true, ticks: { min: 0 } }],
	},
	tooltips: {
		mode: 'index',
		intersect: false,
		filter: (a) => a.yLabel,
	},
	hover: {
		mode: 'nearest',
		intersect: true,
	},
	legend: {
		display: true,
		labels: { fill: false },
	},
};

class Analytic extends Component {
	state = {
		filterType: false,
		filterAgent: false,
		loading: true,
		start_date: this.props.start_date || moment().subtract(7, 'day').startOf('day'),
		end_date: this.props.end_date || moment(),
		agent_role: this.props.access.user.loggedUserObj.role,
		agent_id: this.props.access.user.loggedUserObj.extra.user_id,
		today: moment(),
		group: ['agent'],
		value: _.filter(TypeList, function (it) {
			return !it.uncheck;
		}),
		pid: /* '1e00a47c670273a623c13c54dba44006' || */ /* 'c8e75d60-c03f-11ea-8928-974cce4cd258' || */ this.props.product.live.settings.live.token,
		selectedAgent: 'all',
		selectedDate: 'daily',
		column: null,
		botId: '',
		direction: null,
		dataloading: true,
		displayName: this.props.displayName,
		selectedBarStyle: 'line',
		selectedPlatform: 'all',
		selectedWatsonsGroup: 'all',
		selectedTeam: 'all',
	};
	handleSort = (clickedColumn) => () => {
		const { column, direction } = this.state;
		if (column !== clickedColumn) {
			this.setState({
				column: clickedColumn,
				direction: 'desc',
			});

			return;
		}
		this.setState({
			direction: direction === 'asc' ? 'desc' : 'asc',
		});
	};

	async componentDidMount() {
		let typeQuery = [],
			head = [];
		let pairs = {};
		let group = [];
		let select = [];
		let { start_date, end_date, product } = this.props;
		let { pid, selectedPlatform } = this.state;
		let valueArr = this.state.value.length ? _.orderBy(this.state.value, ['order'], ['asc']) : _.orderBy(TypeList, ['order'], ['asc']);
		_.each(valueArr, (it) => {
			typeQuery = _.concat(typeQuery, it.type);
			if (it.type !== 'activateAgent') head = _.concat(head, it.type);
			if (it.group) {
				if (group.length) group = _.intersection(group, it.group);
				else group = it.group;
			}
			if (it.select) {
				if (select.length) select = _.intersection(select, it.select);
				else select = it.select;
			}
			if (it.pairs) pairs = _.assignIn(it.pairs);
		});

		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		typeQuery = _.uniq(typeQuery);
		head = _.uniq(head);
		if (group.length) group = _.union(group, ['type']);
		if (select.length) select = _.union(select, ['type', 'day']);
		let filter = {};

		await fetch('/api/dahi/message/getLiveChat', {})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					productAgentList:
						data.result &&
						data.result.agents &&
						_.filter(data.result.agents, function (it) {
							return it.type !== 'viewer';
						}),
					productOldAgentList: data.result && data.result.old_agents,
					botId: data.result && data.result.bot.bid,
					bot_id: data.result && data.result.bot.id,
					p_id: data.result && data.result.id,
					chat_groups: data.result && data.result.staticOptions && data.result.staticOptions.groups,
					chat_teams: data.result && data.result.staticOptions && data.result.staticOptions.teams,
				});
			});
		if (this.state.agent_role === 'agent') {
			filter = { type: typeQuery, pid: this.state.pid, agent: this.props.access.user.loggedUserObj.extra.user_id };
			this.setState({ selectedAgent: this.props.access.user.loggedUserObj.extra.user_id });
		} else {
			filter = { type: typeQuery, pid: this.state.pid };
		}
		if (selectedPlatform !== 'all') _.set(filter, 'platform', selectedPlatform);
		else _.unset(filter, 'platform');

		pairs.platform = 'platform';
		fetch('https://log.yapaytech.com/live/test/getInfo?agent_page', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: { pid: this.state.pid, type: ['taken', 'activateAgent', 'forwarded'] },
				select,
				group: ['agent', 'type', 'cid', 'topic', 'date', 'platform'],
				pairs: {
					agent: 'select1',
					platform: 'platform',
					cid: 'select4',
					topic: 'select2',
					date: 'date',
				},
				options: {
					sum: 0,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let agentList = _.map(data.result, function (it) {
					return { key: it.agent, text: it.agent, value: it.agent, id: it.agent };
				});
				this.setState({ head });
				agentList = _.uniqBy(agentList, 'key');
				this.setState({ agentPageData: _.sortBy(data.result, ['agent', 'asc']), agentList: agentList });
			});
		fetch('https://log.yapaytech.com/live/test/getInfo?closed', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: { pid: this.state.pid, type: ['closed'] },
				select,
				group: ['agent', 'type', 'cid', 'topic', 'date', 'platform', 'rate', 'comment', 'device'],
				pairs: {
					agent: 'select1',
					platform: 'platform',
					cid: 'select4',
					topic: 'select2',
					date: 'date',
					rate: 'select5',
					comment: 'select7',
					device: 'select8',
				},
				options: {
					sum: 0,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({ agentPageData_2: _.sortBy(data.result, ['agent', 'asc']) });
			});
		fetch('https://log.yapaytech.com/live/test/getInfo?contact', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: { pid: this.state.pid, type: ['contacted'] },
				select,
				group: ['agent', 'type', 'cid', 'date', 'platform'],
				pairs: {
					agent: 'select1',
					platform: 'platform',
					cid: 'select2',
					date: 'date',
				},
				options: {
					sum: 0,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({ contactedData: _.sortBy(data.result, ['agent', 'asc']) });
			});

		fetch('https://log.yapaytech.com/live/getEvents?opened', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				filter: { pid: this.state.pid, label: 'opened' },
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let result = data && data.result;
				let openedData = _.map(result, (it) => ({
					...it,
					type: 'opened',
					date: it.created_at,
				}));
				this.setState({ openedData: openedData });
			});
		fetch('https://log.yapaytech.com/live/test/getInfo?time_page_1', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: {
					type: ['agentChatTime', 'chatTimeAfterActivate'],
					pid: this.state.pid,
				},
				select,
				group: ['agent', 'type', 'cid', 'platform', 'date'],
				pairs: {
					agent: 'select1',
					platform: 'platform',
					cid: 'select4',
					date: 'date',
				},
				options: {
					sum: 1,
					avg: 1,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({ timePageData: _.sortBy(data.result, ['agent', 'asc']) });
			});
		fetch('https://log.yapaytech.com/live/test/getInfo?time_page_2', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: {
					type: ['agentFirstResponseTimeAfterActivate', 'agentFirstResponseTime'],
					pid: this.state.pid,
				},
				select,
				group: ['agent', 'type', 'cid', 'platform', 'date'],
				pairs: {
					agent: 'select1',
					platform: 'platform',
					cid: 'select2',
					date: 'date',
				},
				options: {
					sum: 1,
					avg: 1,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({ timePageData_2: _.sortBy(data.result, ['agent', 'asc']) });
			});

		fetch('/api/dahi/message/getIntents')
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let intents = data && data.result;
				let whatsapp_intents = data && data.whatsapp_intents;
				this.setState({ intents, whatsapp_intents });
			});

		fetch('https://log.yapaytech.com/live/getWaitingInfo1?ghhgg', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				pid: this.state.pid,
				select: '*',
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let result = data && data.result && data.result.result;
				let ne_result = _.map(result, (it) => {
					let selected = _.find(it, { label: 'activateAgent' }) || it[0];
					return {
						cid: selected.cid,
						count: null,
						user_id: selected.uid,
						date: selected.created_at,
						type: 'activateAgent',
						platform: selected.platform,
					};
				});
				this.setState({
					waitingTotalDataList: ne_result,
				});
			});
		await fetch('https://live.dahi.ai/analytics/dialogtab/userList', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).add(-1, 'h').valueOf(),
				end_date: moment(end_date).add(1, 'h').valueOf(),
				pid: this.state.pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					conversation_list: _.filter(data.data, function (it) {
						return it.conversation_id;
					}),
				});
			});

		fetch('/api/live/agent/list')
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({ newList: data.agents, loading: false });
			});
	}
	exportExcel(sheets, pid, start_date, end_date) {
		let now = Date.now();
		fetch('https://log.yapaytech.com/analytic/download', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				filename:
					moment(start_date).format('DD-MM-YYYY_HH:mm') +
					'_' +
					moment(end_date).format('DD-MM-YYYY_HH:mm') +
					'_agent_status_timeline_' +
					pid +
					'_' +
					'all' +
					'_' +
					now.valueOf(),
				sheets,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let dataurl = data.url;

				var a = document.createElement('a');
				a.href = dataurl;
				a.setAttribute('download', dataurl);
				a.click();
				this.setState({ allClosedloading: false });
			});
	}
	async getData() {
		this.setState({ loading: true, dataloading: true });
		let typeQuery = [],
			head = [];
		let pairs = {};
		let group = [];
		let dayGroup = ['type', 'day', 'agent'];
		let waitGroup = 'day';
		let select = [];
		let { selectedAgent, selectedDate, pid, selectedPlatform, selectedWatsonsGroup, productAgentList, selectedTeam } = this.state;
		let { start_date, end_date, product } = this.props;
		let showingproductAgentList2;
		if (selectedWatsonsGroup !== 'all') {
			showingproductAgentList2 = _.filter(productAgentList, (it) => it.group === selectedWatsonsGroup);
		} else {
			showingproductAgentList2 = productAgentList;
		}
		if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
			if (selectedTeam !== 'all') {
				showingproductAgentList2 = _.filter(productAgentList, (it) => it.team === selectedTeam);
			} else {
				showingproductAgentList2 = productAgentList;
			}
		}
		let livechat_agent = _.find(this.state.productAgentList, (it) => it.id === this.props.access.user.loggedUserObj.extra.user_id);
		if (livechat_agent && livechat_agent.team && !livechat_agent.team_admin) {
			let showingproductAgentList2;
			if (product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.agentTeams) {
				showingproductAgentList2 = _.filter(this.state.productAgentList, (it) => it.team === livechat_agent.team);
				let group_agents = _.map(showingproductAgentList2, (it) => it.id);
				filter = { type: typeQuery, pid: this.state.pid, agent: group_agents };
				pairs.platform = 'platform';
			}
		}
		let group_agents = _.map(showingproductAgentList2, (it) => it.id);
		_.each(_.orderBy(this.state.value, ['order'], ['asc']), (it) => {
			typeQuery = _.concat(typeQuery, it.type);
			if (it.type !== 'activateAgent') head = _.concat(head, it.type);
			if (it.group) {
				if (group.length) group = _.intersection(group, it.group);
				else group = it.group;
			}
			if (it.select) {
				if (select.length) select = _.intersection(select, it.select);
				else select = it.select;
			}
			if (it.pairs) pairs = _.assignIn(it.pairs);
		});
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		//let start_date_s = moment(start_date).add(-1, 'day').format();
		typeQuery = _.uniq(typeQuery);
		head = _.uniq(head);
		if (group.length) group = _.union(group, ['type']);
		if (select.length) select = _.union(select, ['type', 'day']);
		let filter = {};
		if (selectedAgent === 'all') {
			if (selectedWatsonsGroup !== 'all') {
				filter = { type: typeQuery, pid: this.state.pid, agent: group_agents };
			} else {
				if (selectedTeam !== 'all') {
					filter = { type: typeQuery, pid: this.state.pid, agent: group_agents };
				} else {
					filter = { type: typeQuery, pid: this.state.pid };
				}
			}
		} else {
			filter = { type: typeQuery, pid: this.state.pid, agent: selectedAgent };
		}

		if (selectedPlatform !== 'all') _.set(filter, 'platform', selectedPlatform);
		else _.unset(filter, 'platform');
		pairs.platform = 'platform';
		pairs.select1 = 'select1';
		if (!(selectedDate === 'daily')) {
			//filter.day = selectedDate;
			dayGroup = ['type', 'hour'];
			waitGroup = 'hour';
		}
		fetch('https://log.yapaytech.com/live/test/getInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter,
				select,
				group: ['type', 'agent'],
				pairs: { agent: 'select1', select1: 'select1', topic: 'select2', platform: 'platform' },
				options: {
					sum: 0,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let agentList = _.map(data.result, function (it) {
					return { key: it.agent, text: it.agent, value: it.agent };
				});

				this.setState({ head });
				agentList = _.uniqBy(agentList, 'key');
				this.setState({ gettingData: _.sortBy(data.result, ['agent', 'asc']), agentList: agentList, loading: false });
			});
	}
	componentDidUpdate(oldProps, oldState) {
		const check_list = [
			/* 'start_date', 'end_date', */ 'selectedAgent',
			'value',
			'selectedDate',
			'displayName',
			'selectedPlatform',
			'selectedWatsonsGroup',
			'selectedTeam',
			'newDataToggle',
		];
		for (let i = 0; i < check_list.length; i++) {
			const key = check_list[i];
			let timer;
			if (key === 'start_date' || key === 'end_date' || key === 'newDataToggle') {
				if (!_.isEqual(this.props[key], oldProps[key])) {
					window.clearTimeout(timer);
					timer = setTimeout(() => this.componentDidMount(), 1000);
					break;
				}
			}
			if (!_.isArray(this.state[key])) {
				if (this.state[key] !== oldState[key]) {
					window.clearTimeout(timer);
					timer = setTimeout(() => this.componentDidMount(), 3000);
					break;
				}
			} else if (!_.isEqual(this.state[key], oldState[key])) {
				window.clearTimeout(timer);
				timer = setTimeout(() => this.componentDidMount(), 3000);
				break;
			}
		}
	}
	handleFilterChange = (e, { text, value }) => this.setState({ selectedAgent: value, selectedAgentName: text });
	toggle = () => this.setState((prevState) => ({ selectedDate: prevState.selectedDate === 'daily' ? 'hourly' : 'daily' }));
	handleFilterCheck(value) {
		let array = this.state.value || [];
		let exists = _.find(array, value);
		let valueArr = exists ? _.filter(array, (it) => it !== value) : _.concat([], array, value);
		this.setState({ value: valueArr });
	}
	handleChange = (e, { name, value }) => this.setState({ [name]: value });
	handleGroupChange = (e, { text, value }) => this.setState({ group: value });
	filterSelectType = () => {
		this.setState({ filterType: !this.state.filterType });
	};
	showingBar(data, barStyle) {
		switch (barStyle) {
			case 'line':
				return <Line data={data} options={barOptions} />;
			case 'bar':
				return <Bar data={data} options={barOptions} />;
			case 'stackbar':
				return <Bar data={data} options={barOptionsStack} />;
			case 'radar':
				return <Radar data={data} />;
			default:
				return <Line data={data} options={barOptions} />;
		}
	}

	miliToSec(value) {
		return (value / 1000 / 60).toFixed(2);
	}

	formatTime(value) {
		// Ensure value is a number
		value = Number(value);
		const totalSeconds = Math.round(value / 1000); // Convert to seconds and round

		const hours = Math.floor(totalSeconds / 3600);
		const remainingSeconds = totalSeconds % 3600;
		const minutes = Math.floor(remainingSeconds / 60);
		const seconds = remainingSeconds % 60;

		// Format as HH:MM:SS
		return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
	}

	render() {
		let {
			pid,
			p_id,
			productAgentList,
			selectedPlatform,
			productOldAgentList,
			loading,
			selectedWatsonsGroup,
			chat_groups,
			chat_teams,
			selectedTeam,
			agentPageData,
			agentPageData_2,
			timePageData,
			timePageData_2,
			contactedData,
			newList,
			waitingTotalDataList,
			conversation_list,
			intents,
			openedData,
			whatsapp_intents,
		} = this.state;
		const { start_date, end_date, t, i18n, product, platformList } = this.props;

		if (loading) return <Page.Loader></Page.Loader>;
		agentPageData = _.filter(agentPageData, (it) => !/-bot/.test(it.agent));
		let grouped_agent = _.groupBy(agentPageData, 'cid');
		let grouped_time = _.groupBy(timePageData, 'cid');
		let grouped_contacted = _.groupBy(contactedData, 'cid');
		let grouped_agent_2 = _.groupBy(agentPageData_2, 'cid');
		let grouped_time_2 = _.groupBy(timePageData_2, 'cid');
		let grouped_waitingTotalDataList = _.groupBy(waitingTotalDataList, 'cid');
		let grouped_openedData = _.groupBy(openedData, 'cid');
		//console.log('agentPageData_2', grouped_agent_2);
		// Sonra grupları birleştirme
		let grouped_by_cid = {};
		for (let cid in grouped_waitingTotalDataList) {
			grouped_by_cid[cid] = [
				...(grouped_agent[cid] || []),
				...(grouped_time[cid] || []),
				...(grouped_contacted[cid] || []),
				...(grouped_agent_2[cid] || []),
				...(grouped_time_2[cid] || []),
				...(grouped_waitingTotalDataList[cid] || []),
				...(grouped_openedData[cid] || []),
			];
		}
		console.log('grouped_by_cid', grouped_by_cid);
		let excel_data = [];

		for (let cid in grouped_by_cid) {
			let obj = { cid };
			let data = grouped_by_cid[cid];
			let agent_id = '';
			for (let i = 0; i < data.length; i++) {
				let item = data[i];
				if (item.type === 'taken') agent_id = item.agent;
				if (item.topic) obj.topic = item.topic;
				if (item.topic) obj.konu = item.topic;
				if (item.rate) obj.rate = item.rate;
				if (item.comment) obj.comment = item.comment;
				if (item.device) obj.device = item.device;
				if (item.forward_intent) obj.forward_intent = item.forward_intent;
				obj.platform = item.platform === 'web' ? 'flo' : item.platform;
				obj.widget_name = item.platform === 'web' ? 'flo' : item.platform;
				obj.kuyruk = item.platform === 'web' ? 'flo' : item.platform;
				obj.cid = item.cid;
				obj.chat_type = 'chat';

				obj[item.type] = this.formatTime(item.sum) || this.formatTime(item.agent) || item.count;
				obj[item.type + '_datetime'] = moment(item.date).format('YYYY-MM-DD HH:mm:ss');
				obj[item.type + '_datetime2'] = moment(item.date).format('YYYY-MM-DD HH:mm:ss');

				if (item.type === 'agentFirstResponseTimeAfterActivate') {
					obj.sl_20 = 0;
					obj.sl_30 = 0;
					if (item.sum <= 20000) obj.sl_20 = 1;
					if (item.sum <= 30000) obj.sl_30 = 1;
				}

				if (item.type === 'agentFirstResponseTime') {
					obj.sl_20_by_agent = 0;
					obj.sl_30_by_agent = 0;
					if (item.sum <= 20000) obj.sl_20_by_agent = 1;
					if (item.sum <= 30000) obj.sl_30_by_agent = 1;
				}

				if (item.type === 'closed') {
					let _agent = _.find(newList, (it) => it.extra && it.extra.user_id === agent_id);
					obj.closed_by = _agent ? _agent.email : 'user';
				}

				if (item.type === 'activateAgent') {
					obj.user_id = item.user_id;
				}

				if (item.type === 'opened') {
					obj.start_interval = moment(item.date).format('HH');
				}
			}
			let _agent = _.find(newList, (it) => it.extra && it.extra.user_id === agent_id);
			if (_agent) {
				let __agent = _.find(productAgentList, (it) => it.id === agent_id);
				if (__agent && __agent.team) {
					let team = _.find(chat_teams, (o) => o.id === __agent.team);
					_agent.team = __agent.team;
					_agent.team_admin = __agent.team_admin;
					_agent.team_name = team && team.label;
				}
				if (__agent && __agent.team_leader_name) obj.team_leader_name = __agent.team_leader_name;
				if (__agent && __agent.location_name) obj.location_name = __agent.location_name;
				if (__agent && __agent.sicil) obj.sicil = __agent.sicil;
			}

			if (!_agent) {
				_agent = _.find(productAgentList, (it) => it.id === agent_id);
				if (_agent) {
					_agent.email = _agent.developer;
					_agent.name = _agent.developer;
				}
			}

			if (!_agent) {
				_agent = _.find(productOldAgentList, (it) => it.id === agent_id);
				if (_agent) {
					_agent.email = _agent.developer;
					_agent.name = _agent.developer;
				}
			}

			if (_agent) {
				obj.email = _agent && _agent.email;
				obj.name = _agent && (_agent.name || _agent.email);
				obj.agent = agent_id;
				if (_agent.team_name) obj.team = _agent.team_name;
			}

			if (!obj.user_info) {
				let _conv = _.find(conversation_list, (it) => it.conversation_id === obj.cid);
				if (_conv) {
					let forward_intent = _conv.starting_forward_intent ? _.find(intents, (it) => it._id === _conv.starting_forward_intent) : '';
					obj.user_name = _conv.name;
					obj.user_email = _conv.email;
					obj.user_ip = _conv.ip;
					obj.forward_intent = (forward_intent && forward_intent.name) || _conv.starting_forward_intent;
					obj.starting_forward_intent = _conv.starting_forward_intent;
					obj.device = _conv.is_mobile ? 'Mobil' : 'Pc';
					obj.device_op = _conv.is_mobile
						? _conv.link && _conv.link.page_url
							? /android/.test(_conv.link.page_url)
								? 'Android'
								: 'Ios'
							: 'bilinmiyor'
						: 'web';
					obj.last_state = _conv.state.closed
						? 'Kapalı'
						: _conv.state.contactedByAgent
						? 'Agent Üstünde'
						: _conv.state.waitingAgent
						? 'Bekleyende'
						: 'Botta';
				}
			}

			excel_data.push(obj);
		}

		console.log('grouped_by_cid', openedData, excel_data);
		//excel_data = _.filter(excel_data, (it) => it.contacted_datetime);
		console.log('excel_data', excel_data);
		let sheets = [
			{
				name: 'raw_analytic',
				x: [
					{ title: 'E-posta', key: 'email' },
					{ title: 'İsim', key: 'name' },
					{ title: 'Sicil', key: 'sicil' },
					{ title: 'Takım', key: 'team' },
					{ title: 'Takım Lideri', key: 'team_leader_name' },
					{ title: 'Konu', key: 'konu' },
					{ title: 'Tarih-Saat', key: 'activateAgent_datetime2' },
					{ title: 'Müşteri Adı', key: 'user_name' },
					{ title: 'Müşteri E-Posta', key: 'user_email' },
					{ title: 'Lokasyon', key: 'location_name' },
					{ title: 'Kuyruk Adı', key: 'kuyruk' },
					{ title: 'Statu', key: 'last_state' },
					{ title: 'Etiket', key: 'topic' },
					{ title: 'Chat Tipi', key: 'chat_type' },
					{ title: 'Chat Başlama (botta başlama)', key: 'opened_datetime' },
					{ title: 'Chat Başlama (bottan bekleyene aktarılma)', key: 'activateAgent_datetime' },
					{ title: 'Chat Agenta Atanma (bekleyenden mt üzerinde atılma)', key: 'taken_datetime' },
					{ title: 'Chate Agentın İlk Cevabı (mtnin bağlandıktan sonra ilk cevabı)', key: 'contacted_datetime' },
					{ title: 'Chat Bitiş (konuşmanın bitmesi)', key: 'closed_datetime' },
					{ title: 'Ziyaretçi Yolu', key: 'forward_intent' },
					{ title: 'Cihaz', key: 'device' },
					{ title: 'Cihaz İşletim', key: 'device_op' },
					{ title: 'Platform', key: 'platform' },
					{ title: 'Chat ID', key: 'cid' },
					{ title: 'rate', key: 'rate' },
					{ title: 'Yorum', key: 'comment' },
					{ title: 'Aktarım ( Lokal Kapama )', key: 'team_leader3' },
					{ title: 'Agent Konuşma Süresi (dakika)', key: 'agentChatTime' },
					{ title: 'Agent Konuşma Süresi (saniye )', key: 'agentChatTime' },
					{ title: 'Active Chat Key', key: 'team_leader4' },
					{ title: 'ICR Mesai Dışı Notu', key: 'team_leader5' },
					{ title: 'Widget Adı', key: 'platform' },
					{ title: 'Cevaplama Süresi (Bekleyen-Agent Cevap)', key: 'agentFirstResponseTimeAfterActivate' },
					{ title: '20 Saniye İçinde Cevaplama (Bekleyen-Agent Cevap)', key: 'sl_20' },
					{ title: '30 Saniye İçinde Cevaplama (Bekleyen-Agent Cevap)', key: 'sl_30' },
					{ title: 'Cevaplama Süresi (Agent Bağlanma-Agent Cevap)', key: 'agentFirstResponseTime' },
					{ title: '20 Saniye İçinde Cevaplama (Agent Bağlanma-Agent Cevap)', key: 'sl_20_by_agent' },
					{ title: '30 Saniye İçinde Cevaplama (Agent Bağlanma-Agent Cevap)', key: 'sl_30_by_agent' },
					{ title: 'Başlangıç Interval', key: 'start_interval' },
					{ title: 'Sonlandıran', key: 'closed_by' },
				],
				datasets: _.flatten(excel_data),
			},
		];
		return (
			<Container>
				<Segment style={{ marginBottom: '20px' }}>
					<div style={{ marginTop: '10px', display: 'flex' }}>
						<Button
							icon
							labelPosition="left"
							color="green"
							style={{ marginLeft: 'auto' }}
							onClick={() => this.exportExcel(sheets, pid, start_date, end_date)}
						>
							<Icon name="file excel outline" />
							{t('downloadExcel')}
						</Button>
					</div>
				</Segment>
			</Container>
		);
	}
}

const stateToProps = (state) => ({ access: state.access, location: state.router.location, product: state.product });

export default connect(stateToProps)(withTranslation()(Analytic));
